/**
 * How a sold home's figures read, on its card and its page. Moved here from apps/tenant-sites
 * lib/sold.ts (which re-exports them) so the Studio's /sold preview draws the live cards.
 */
export interface SoldFigures {
  close_price: number | null;
  beds: number | null;
  baths: number | null;
  sqft: number | null;
}

export const money = (n: number): string => `$${Math.round(n).toLocaleString('en-US')}`;

/** "$612,000" when the feed carried a price, else null (the page omits the figure). */
export function soldPriceLabel(sold: Pick<SoldFigures, 'close_price'>): string | null {
  return sold.close_price != null && sold.close_price > 0 ? money(sold.close_price) : null;
}

export function soldDateLabel(iso: string | null | undefined): string | null {
  if (!iso) return null;
  const d = new Date(`${iso.slice(0, 10)}T00:00:00Z`);
  return Number.isNaN(d.getTime()) ? null : d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
}

/** "3 bd · 2 ba · 1,850 sq ft" from whatever the feed gave. */
export function soldFactsLine(sold: Pick<SoldFigures, 'beds' | 'baths' | 'sqft'>): string {
  const parts: string[] = [];
  if (sold.beds != null) parts.push(`${sold.beds} bd`);
  if (sold.baths != null) parts.push(`${Number(sold.baths) % 1 === 0 ? Number(sold.baths) : sold.baths} ba`);
  if (sold.sqft != null && sold.sqft > 0) parts.push(`${Math.round(sold.sqft).toLocaleString('en-US')} sq ft`);
  return parts.join(' · ');
}
